// extracted by mini-css-extract-plugin
module.exports = {"button":"button-module--button--1Tg9s","buttonInvert":"button-module--buttonInvert--TVW6Y"};